import React, { Component } from 'react';
// import {Link} from 'react-router-dom'

class EducationRight extends Component {
    constructor(props){
        super(props);
        this.state = {
            skill: [
                {
                    id: 1,
                    timeline: 'timeline-inverted color1',
                    info: 'Jhadeswar Science College',
                    title: 'Higher Secondary',
                    text: 'Completed Higher Secondary Education and learned core concepts of science along with preparing for JEE Mains.'
                },
                {
                    id: 2,
                    timeline: 'timeline-inverted color2',
                    info: 'Utkal University',
                    title: "Bachelor's of science in Physics",
                    text: "Studied some advanced and interesting concepts in physics while persuing my Bachelors."
                },
                {
                    id: 3,
                    timeline: 'timeline-inverted color3',
                    info: 'Masai School',
                    title: 'Full-Stack Web Developement',
                    text: 'Learning Full-Stack Web Developement and creating some cool new websites.'
                }
            ]
        }
    }
    render() {
        return (
            <div className="col-right">
                <div className="flat-spacer" data-desktop={0} data-mobile={70} data-smobile={70} />
                <div className="flat-title t1 animate-element wow delay5 fadeInDown">
                    <h4 className="sub-title mg-b13">Educational qualification</h4>
                    <h2 className="title-section color-d12">My Education</h2>
                </div>
                <div className="timelines position-relative animate-element wow delay5 fadeInUp" data-wow-delay="0.5s">
                    <ul className="timeline">
                        {
                            this.state.skill.map(data => (
                                <li className={data.timeline} key={data.id}>
                                    <div className="timeline-badge" />
                                    <div className="timeline-panel">
                                        <h3 className="f-info">{data.info}</h3>
                                        <div className="s-info">{data.title}</div>
                                        <p>
                                            {data.text}
                                        </p>
                                    </div>
                                </li>
                            ))
                        }
                        
                    </ul>
                    <div className="fl-btn btn-general btn-hv-border">
                        <a href="https://drive.google.com/drive/folders/1JRVlLTdkM7iLT7KLy4D5BmmoT3j0DN9Y?usp=sharing" target="_blank" rel="noreferrer" className="f-w500 lt-sp1 border-corner2 text-one">Download Resume</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default EducationRight;
